module.exports = __webpack_public_path__ + "static/media/javalogo.a19aad8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/javalogo.png
// module id = 825
// module chunks = 0